import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {BulletPointsModel} from "../models/view/bulletPointsModel";
import {useRefsContext} from "../utils/refContext";
import {useAppDispatch} from "../redux/stateHooks";
import {openAccordionItemIfClosed} from "../redux/slices/accordion";
import {AccordionItemType} from "../definitions/enums";
import {useScreenSizeDetector} from "./useScreenSizeDetector";

export const useBulletPointsQuery = () => {
    const dispatch = useAppDispatch();
    const {productDetailsAccordionRef} = useRefsContext();
    const {model: {aggregatedBulletPoints}} = useProductDetailsQuery();
    const model = new BulletPointsModel(aggregatedBulletPoints);
    const {isSmallScreenSize} = useScreenSizeDetector();
    const padding = isSmallScreenSize ? 50 : 100;

    const scrollAndOpenProductDetails = () => () => {

        const productDetailsAccordionItem = productDetailsAccordionRef.current;

        if (productDetailsAccordionItem) {
            // Calculate the offset from the top of the viewport with padding
            const offset = productDetailsAccordionItem.getBoundingClientRect().top + window.scrollY - padding;

            // Scroll to the product details accordion item with padding
            window.scrollTo({top: offset, behavior: "smooth"});

            // Ensure the product details accordion item is open
            dispatch(openAccordionItemIfClosed(AccordionItemType.ProductDetails));
        }
    };

    return {
        model,
        onClick: scrollAndOpenProductDetails()
    };
}